import { ButtonHTMLAttributes } from 'react'

export const MediaButton: React.FC<
  React.PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>
> = ({ children, className, disabled, ...props }) => (
  <button
    disabled={disabled}
    className="bg-surface-secondary-default bg-opacity-70 px-4 py-3 text-sm flex gap-x-2"
    {...props}
  >
    {children}
  </button>
)
